import React, { useEffect, useState, useRef } from 'react';
import {
    Box, Card, Typography, Table, TableHead, TableRow, TableCell,
    TableBody, Paper, Button
} from '@mui/material';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import Shopheader from '../Shop/Shopheader';
import Mashalheader from '../Mashal/Mashalheader';
import Wholesalerheader from '../Wholesale/Wholesaleheader';

export default function VendorOutstandingReport() {
    const [Vendors, setVendors] = useState([]);
    const [VendorAccounts, setVendorAccounts] = useState({});
    const category = 'shop'; // replace with useParams() if dynamic
    const printRef = useRef();

    useEffect(() => {
        fetchVendorsAndAccounts();
    }, [category]);

    const fetchVendorsAndAccounts = async () => {
        try {
            const q = query(collection(db, 'vendors'));
            onSnapshot(q, (snap) => {
                const VendorData = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setVendors(VendorData);

                VendorData.forEach(Vendor => {
                    const PurchasesQuery = query(collection(db, 'purchases'), where('dealerId', '==', Vendor.id));
                    onSnapshot(PurchasesQuery, (snapPurchases) => {
                        let grand = 0;
                        snapPurchases.docs.forEach(p => {
                            grand += parseFloat(p.data().grandTotal || 0);
                        });

                        const paymentsQuery = query(
                            collection(db, 'vendorpaymenthistory'),
                            where('dealerId', '==', Vendor.id)
                        );
                        onSnapshot(paymentsQuery, (snapPayments) => {
                            let paid = snapPayments.docs.reduce((acc, doc) => acc + parseFloat(doc.data().amount || 0), 0);
                            const remaining = grand - paid;
                            if (remaining > 0) { // only vendors with remaining
                                setVendorAccounts(prev => ({
                                    ...prev,
                                    [Vendor.id]: {
                                        grandTotal: grand.toFixed(2),
                                        paidTotal: paid.toFixed(2),
                                        remainingTotal: remaining.toFixed(2),
                                        name: Vendor.name,
                                        mobile: Vendor.mobile,
                                        address: Vendor.address || '-'
                                    },
                                }));
                            }
                        });
                    });
                });
            });
        } catch (error) {
            console.error(error.message);
        }
    };

    const totals = Object.values(VendorAccounts).reduce(
        (acc, curr) => {
            acc.grandTotal += parseFloat(curr.grandTotal);
            acc.paidTotal += parseFloat(curr.paidTotal);
            acc.remainingTotal += parseFloat(curr.remainingTotal);
            return acc;
        },
        { grandTotal: 0, paidTotal: 0, remainingTotal: 0 }
    );

    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
            <html>
                <head>
                    <title>विक्रेता उधारी रिपोर्ट </title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                        th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                        th { background-color: #1976d2; color: #fff; }
                        h2,h4 { margin: 5px 0; }
                    </style>
                </head>
                <body>
                    ${content}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };

    return (
        <Box p={3} mt={10}>
            {category === "shop" && <Shopheader />}
            {category === "mashal" && <Mashalheader />}
            {category === "wholesaler" && <Wholesalerheader />}

            <Card sx={{ p: 2, mb: 2 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    विक्रेता उधारी रिपोर्ट
                </Typography>
                <Button variant="contained" color="primary" onClick={handlePrint} sx={{ mb: 2 }}>
                    Print Report
                </Button>
            </Card>

            <Box ref={printRef}>
                <Card sx={{ p: 2 }}>
                    <Paper sx={{ p: 2, overflowX: "auto" }}>
                        <Table size="small">
                            <TableHead sx={{ backgroundColor: '#1976d2' }}>
                                <TableRow>
                                    <TableCell sx={{ color: '#fff' }}>Sr No</TableCell>
                                    <TableCell>विक्रेता नाव </TableCell>
                                    <TableCell>मोबाईल </TableCell>
                                    <TableCell>खरेदी टोटल </TableCell>
                                    <TableCell>टोटल जमा </TableCell>
                                    <TableCell>टोटल बाकी </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.values(VendorAccounts).map((vendor, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{vendor.name}</TableCell>
                                        <TableCell>{vendor.mobile}</TableCell>
                                        <TableCell>₹{parseFloat(vendor.grandTotal).toFixed(2)}</TableCell>
                                        <TableCell>₹{parseFloat(vendor.paidTotal).toFixed(2)}</TableCell>
                                        <TableCell>₹{parseFloat(vendor.remainingTotal).toFixed(2)}</TableCell>
                                    </TableRow>
                                ))}
                                {Object.values(VendorAccounts).length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">No outstanding vendors.</TableCell>
                                    </TableRow>
                                )}

                                {/* Totals */}
                                <TableRow sx={{ backgroundColor: 'rgba(25,118,210,0.1)' }}>
                                    <TableCell colSpan={3} align="right"><b>Total</b></TableCell>
                                    <TableCell><b>₹{totals.grandTotal.toFixed(2)}</b></TableCell>
                                    <TableCell><b>₹{totals.paidTotal.toFixed(2)}</b></TableCell>
                                    <TableCell><b>₹{totals.remainingTotal.toFixed(2)}</b></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Card>
            </Box>
        </Box>
    );
}
